export enum UserRoleType {
  CUSTOM = 'CUSTOM',
  STATIC = 'STATIC',
  BUNDLED = 'BUNDLED',
  SYSTEM = 'SYSTEM',
  SHARED = 'SHARED',
}

export enum DefaultValue {
  ALL_ROLES = 'ALL_ROLES',
}

export enum UserRoleNotificationType {
  DELETE_USER_ROLE_SUCCESS = 'DELETE_USER_ROLE_SUCCESS',
  DELETE_USER_ROLE_ERROR = 'DELETE_USER_ROLE_ERROR',
  CREATE_USER_ROLE_SUCCESS = 'CREATE_USER_ROLE_SUCCESS',
  CREATE_USER_ROLE_ERROR = 'CREATE_USER_ROLE_ERROR',
  EDIT_USER_ROLE_SUCCESS = 'EDIT_USER_ROLE_SUCCESS',
  EDIT_USER_ROLE_ERROR = 'EDIT_USER_ROLE_ERROR',
}
